/* DONOR PROFILE */
export const GET_DONOR_SETTINGS = "GET_DONOR_SETTINGS";
export const GET_DONOR_SETTINGS_SUCCESS = "GET_DONOR_SETTINGS_SUCCESS";
export const GET_DONOR_SETTINGS_FAIL = "GET_DONOR_SETTINGS_FAIL";

export const UPDATE_DONOR_SETTINGS = "UPDATE_DONOR_SETTINGS";
export const UPDATE_DONOR_SETTINGS_SUCCESS = "UPDATE_DONOR_SETTINGS_SUCCESS";
export const UPDATE_DONOR_SETTINGS_FAIL = "UPDATE_DONOR_SETTINGS_FAIL";

// Territories
export const GET_TERRITORIES_LIST =
  "GET_TERRITORIES_LIST";
export const GET_TERRITORIES_LIST_SUCCESS =
  "GET_TERRITORIES_LIST_SUCCESS";
export const GET_TERRITORIES_LIST_FAIL =
  "GET_TERRITORIES_LIST_FAIL";